module.exports = __webpack_public_path__ + "img/lib.c8c7d525.webp";